import { MODEL_TYPE } from '@constants'
import { AutocompleteOption, CommandParameterDTO } from '@types'

import { BarChartResponseType } from '../../../types/api/barChart.api'

export type SeriesType = {
  id?: number
  title: string
  order: number
  dateRange: {
    from: string
    till: string
  }
}

export const seriesTypeString = `{
  title: string,
  order: number,
  dateRange: {
    from: string,
    till: string
  }
}`

export type FieldType = {
  id?: number
  title: string
  value?: string | AutocompleteOption
  bindType: AutocompleteOption
  seriesId?: number
}

export type ColumnType = {
  id?: number
  code: string
  order?: number
  title: string
  operation: AutocompleteOption
  prefilter: string
  object?: AutocompleteOption
  parameters: {
    color?: string
    colorId?: number
  }
  fields: FieldType[]
  command?: any //TODO
  commandParameters?: CommandParameterDTO[]
  commandBody?: CommandParameterDTO[]
  commandForEverySeries: boolean
  jsForAllFields: boolean
  jsCreateValue?: string
  color: string
}

export type ResourceType = {
  id?: number
  viewId: number
  columnId: number
  filter: string
  objectCode: string
  objectTitle: string
  viewTitle: string
}

export type TimelineType = {
  id?: number
  axisX: AutocompleteOption
  period: AutocompleteOption
  dateRange: string[]
  timeIncrement: AutocompleteOption
  formatDate: AutocompleteOption
  series: SeriesType[]
  hideFilters: boolean
}

export type ConfigBarChartForm = {
  id?: number
  internalId?: string
  code?: string
  title?: string
  timeline: TimelineType
  columns: ColumnType[]
  resources: ResourceType[]
}

export type PageContextType = {
  showDialog: boolean
  objects: AutocompleteOption[]
  modalType: MODEL_TYPE
  onCloseModal: (isDirty: boolean) => void
  series: SeriesType[]
  updateDiagramData: (data: BarChartResponseType) => void
  diagramId: string | number
  editColumnData: ColumnType
}
